<template lang="pug">
  div
    template(
      v-if="loaded")
      .list-mobile
        mixer-uploads-item-mobile(
        v-for="item in upload"
        :key="item.id"
        :item="item")

      v-table-body(
        v-if="loaded"
        outsideTable
        :empty="!upload.length")

    template(v-else)
      v-card.mb-3(v-for="i in 5" :key="i")
        .list-mobile.list-mobile--skeleton
          .list-mobile__top
            .list-mobile__title-skeleton
          .list-mobile__content
            .list-mobile__item(v-for="j in 10" :key="`${i}-${j}`")
              .list-mobile__item-skeleton.list-mobile__item-skeleton--type-1
              .list-mobile__item-skeleton.list-mobile__item-skeleton--type-1
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import filterMixin from '@/mixins/filter.mixin'
import MixerUploadsItemMobile from './MixerUploadsItemMobile'

export default {
  name: 'MixerUploadsListMobile',

  mixins: [filterMixin],

  components: {
    MixerUploadsItemMobile
  },

  data: () => ({
    loaded: false
  }),

  computed: {
    ...mapGetters('reports', [
      'upload',
      'filters',
      'totalCount'
    ])
  },

  mounted () {
    this.loadData()
  },

  methods: {
    ...mapActions('reports', [
      'getUpload'
    ]),

    async loadData () {
      this.loaded = false
      this.filters.page = this.page > 1 ? this.page : null
      await this.getUpload(this.filters)
      this.loaded = true
    }
  },

  watch: {
    page () {
      this.loaded = false
    }
  }
}
</script>
